<template>
  <div >
    <router-view></router-view>
    <index-card :loading="all_loadings">
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
        </div>
        <div class="d-flex align-center">
          <span class="headline white--text">
            Paletes
          </span>
          <v-btn text icon @click="getPickupLocations()" exact><v-icon class="white--text">mdi-refresh</v-icon></v-btn>
        </div>
      </template>
      <template slot="subheader">
        <div class="pallets-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquise.."
            :extra-filters-count="2"
            :loading_block="all_loadings"
            @doneFilter="handleDoneFilter"
          >
            <template v-slot:extra-filters>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="selected_pickup_location"
                  return-object
                  :items="pickup_locations"
                  item-value="id"
                  item-text="attributes.name"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-pin"
                  label="Local de Retira"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="selected_seller_id"
                  :items="employees"
                  item-value="id"
                  item-text="attributes.name"
                  clearable
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-account"
                  label="Vendedor"
                />
              </v-col>
            </template>
          </filter-data>
        </div>
      </template>
      <template slot="data_table">
        <v-data-table :headers="headers" :items="pallets_history"
          class="elevation-4" :search="search" mobile-breakpoint="1">
          <template v-slot:top>
            <div class="d-flex justify-center align-center flex-wrap">
              <BtnEditPallets v-if="pickup_location" @updated="getData()" remove :pickup_location_id="pickup_location?.id" :default_employee_id="seller_id"></BtnEditPallets>
              <InfoCard v-if="pickup_location?.id && !seller_id" icon="mdi-shipping-pallet" color="green darken-2">
                <template slot="content">
                  <div  class="d-flex flex-column">
                    <span>{{ pickup_location?.attributes.name }}</span>
                    <span>{{ pickup_location?.attributes?.quantity_of_pallets }} Paletes total no local</span>
                  </div>
                </template>
              </InfoCard>
              <InfoCard v-if="seller_id && pickup_location?.id" icon="mdi-account-hard-hat" color="blue darken-2">
                <template slot="content">
                  <div class="d-flex flex-column">
                    <span>{{ getEmployeeName(seller_id) }}</span>
                    <span>{{ employee_stock_quantity }} Paletes do vendedor</span>
                  </div>
                </template>
              </InfoCard>
              <BtnEditPallets v-if="pickup_location"  @updated="getData()" :pickup_location_id="pickup_location?.id" :default_employee_id="seller_id"></BtnEditPallets>
            </div>
          </template>
          <template v-slot:item.attributes.created_at="{item}">
            {{ $moment(item.attributes.created_at).format('DD/MM/YYYY') }}
          </template>
          <template v-slot:item.kind="{item}">
            <v-chip :color="kind_map[item.attributes?.kind].color">{{ kind_map[item.attributes?.kind].text }}</v-chip>
          </template>
          <template v-slot:item.attributes.client_name="{item}">
            <span v-if="item.attributes.client_name">{{ item.attributes.client_name }}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.attributes.driver_name="{item}">
            <span v-if="item.attributes.driver_name">{{ item.attributes.driver_name }}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.attributes.plate="{item}">
            <span v-if="item.attributes.plate">{{ item.attributes.plate }}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.attributes.seller_name="{item}">
            <span v-if="item.attributes.seller_name">{{ item.attributes.seller_name }}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.attributes.order_id="{item}">
            <div class="d-flex align-center justify-center" v-if="item.attributes.order_id">
              <span class="mr-1">{{ item.attributes.order_id }}</span>
              <v-btn small icon @click="goToOrder(item)">
                <v-icon small>mdi-open-in-new</v-icon>
              </v-btn>
            </div>
            <span v-else>-</span>
          </template>
          <template v-slot:item.attributes.employee_name="{item}">
            <div class="d-flex align-center">
              <v-tooltip top color="black" v-if="item.attributes.comment">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" small icon text class="ml-1">
                    <v-icon small>mdi-message-reply-text</v-icon>
                  </v-btn>
                </template>
                {{item.attributes.comment}}
              </v-tooltip>
              <span>{{ item.attributes.employee_name }}</span>
            </div>
          </template>
          <template v-slot:item.actions="{item}">
            <div class="d-flex justify-center align-center">
              <v-btn small icon class="primary">
                <v-icon class="white--text" small>mdi-history</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </template>
    </index-card>
  </div>
</template>

<script>
import Api from '@/api/index';
import cimentao_links from "@/mixins/cimentao_links";

export default {
  name: 'Pallets',
  mixins: [ cimentao_links ],
  components:{
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    InfoCard: () => import("@/_backoffice/_financial/components/envelope/shared/InfoCard.vue"), 
    BtnEditPallets: () => import("@/_backoffice/_registrations/components/pickup_locations/BtnEditPallets.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      loading: {
        pickup_locations: false,
        employees: false,
        pallets_history: false,
      },
      search: '',
      pallets_history: [],
      employees: [],
      pickup_locations: [],
      local_filter: {
        index_serializer: true
      },
      pickup_location: null,
      seller_id: null,
      selected_pickup_location: null,
      selected_seller_id: null,
      employee_stock_quantity: 0,
      kind_map: {
        'entry':{ text:"Entrada", color:"success"},
        'exit':{ text:"Saída", color:"error"},
        'adjustment':{ text:"Ajuste"},
      },
      headers: [
        { text: 'Data', value: 'attributes.created_at', align: 'center' },
        { text: 'Quantidade', value: 'attributes.quantity', align: 'center' },
        { text: 'Vendedor', value: 'attributes.seller_name', align: 'center' },
        { text: 'Cliente', value: 'attributes.client_name', align: 'center' },
        { text: 'Motorista', value: 'attributes.driver_name', align: 'center' },
        { text: 'Placa', value: 'attributes.plate', align: 'center' },
        { text: 'Pedido', value: 'attributes.order_id', align: 'center', sortable: false },
        { text: 'Alterado por', value: 'attributes.employee_name', align: 'center' },
        { text: 'Tipo', value: 'kind', align: 'center' },
      ],
    }
  },
  computed:{
    all_loadings(){
      return Object.values(this.loading).some(valor => valor == true);
    },
  },
  methods: {
    getData(){
      this.getPickupLocations()
      this.getEmployees()
      this.getPalletsHistory()
      this.getEmployeeStock()
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
      this.pickup_location = this.selected_pickup_location
      this.seller_id = this.selected_seller_id
    },
    getEmployeeName(employee_id) {
      const employee = this.employees.find(e => e.id === employee_id)
      return employee?.attributes?.name || 'Vendedor'
    },
    getEmployeeStock() {
      if (this.seller_id && this.pickup_location?.id) {
        Api.PalletsHistory.getEmployeeStock({
          employee_id: this.seller_id,
          pickup_location_id: this.pickup_location.id
        }).then(r => r.data).then(data => {
          this.employee_stock_quantity = data.quantity || 0
        }).catch(err => {
          console.error(err)
          this.employee_stock_quantity = 0
        })
      } else {
        this.employee_stock_quantity = 0
      }
    },
    getPickupLocations(){
      this.loading.pickup_locations = true
      this.pickup_locations = []
      Api.PickupLocation.index({index_serializer: true}).then((res)=>{
        this.pickup_locations  = [...res.data.data]
      }).finally(()=>{
        this.loading.pickup_locations = false
      })
    },
    getEmployees(){
      this.employees = []
      let params = this.getEmployeesParams()
      this.loading.employees = true
      Api.Employee.index(params).then(res => res.data).then(data => {
        this.employees = data.data
      }).finally(() => {
        this.loading.employees = false
      })
    },
    getPalletsHistory(){
      if(this.pickup_location){
        this.pallets_history = []
        this.loading.pallets_history = true
        let params = {
          pickup_location_id: this.pickup_location.id,
          employee_id: this.seller_id,
        }
        Api.PalletsHistory.index(params).then( res => {
          this.pallets_history  = [...res.data.data]
        }).finally(() => {
          this.loading.pallets_history = false
        })
      }
    },
    getEmployeesParams(){
      let params = {
        short: true,
        by_roles: ["Manager", "Seller"],
      }
      return params
    },
    goToOrder(pallets_history_item){
      if(pallets_history_item?.attributes?.solution == 'retail'){
        this.goToRetailPage(pallets_history_item?.attributes?.order_id)
      }else{
        this.goToWholesalePage(pallets_history_item?.attributes?.order_id)
      }
    }
  },
  mounted() {
    this.getData()
  },
  watch:{
    pickup_location(){
      this.getPalletsHistory()
      this.getEmployeeStock()
    },
    seller_id(){
      this.getPalletsHistory()
      this.getEmployeeStock()
    },
  }
}
</script>

<style scoped>
.pallets-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.pallets-filters >>> .filter-data-card {
  width: 100%;
}
</style>